export const environment = {
  appTitle: "Jitsu-do BJJ Training Tool",
  production: true,
  apiHost: 'trainingtool.zettabot.ca',
  apiUrl: 'https://trainingtool.zettabot.ca/trainingtool/api/v3',
  curriculum: '6674a30b07c7add67fc4de74',
  curriculumName: 'Jitsu-Do BJJ',
  envName: 'prod'
};